import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { IMeterPointAgreement } from "@/models/meterpointAgreement/meterpointAgreement.types"
import { MeterpointService } from "@/services/MeterpointService"
import { AccountService } from "@/services/AccountService"

export const getAccountAgreementsByMeterPoint = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  const meterpointsQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterpointsQuery)

  const agreements = meterpointsQuery.data.reduce(
    (meterpointAgreementsMap, meterpoint) => {
      let agreements: IMeterPointAgreement[] = []
      if (coreIdQuery.data) {
        const query = MeterpointService.getMeterPointAgreements(
          coreIdQuery.data,
          meterpoint.identifier,
        )
        queries.add(query)
        agreements = query.data
      }

      meterpointAgreementsMap[meterpoint.identifier] = agreements
      return meterpointAgreementsMap
    },
    {} as Record<string, IMeterPointAgreement[]>,
  )

  return queries.setData(agreements).getAggregate()
}
